<template>
  <div id="register" :class="popupClasses">
    <div class="close__wrapper">
      <div class="popup__close" @click.prevent="closeModal(modal.name)">
        <img alt="image" src="@/assets/img/new/close.svg" />
      </div>
      <div class="header__popup">
        <span class="button-borderxl button-vxl">Регистрация</span>
        <span class="button-borderxl" @click="Login()">Вход</span>
      </div>
      <ValidationObserver v-slot="{ passes }">
        <form class="footer__popup" @submit.prevent="passes(register)">
          <div class="inputblock-reg">
            <span class="subtitle"> Логин </span
            ><AppInput
              class=""
              rules="required"
              v-bind="{ bg, label: 'Логин', type: 'text' }"
              v-model="login"
            />
          </div>
          <div class="inputblock-reg">
            <span class="subtitle">
              Электронная почта
            </span>
            <AppInput
              class=""
              rules="required|email"
              v-bind="{ bg, label: 'Email', type: 'text' }"
              v-model="email"
            />
          </div>
          <div class="inputblock-reg">
            <span class="subtitle"> Пароль </span
            ><AppInput
              class=""
              rules="required|password:@confirm"
              v-bind="{ bg, label: 'Пароль', type: passwordType, pass: true }"
              @updatePass="updatePass"
              v-model="password"
            />
          </div>
          <div class="inputblock-reg">
            <span class="subtitle">
              Повторите пароль
            </span>
            <AppInput
              class=""
              name="confirm"
              rules="required"
              v-bind="{
                bg,
                label: 'Повторите пароль',
                type: passwordConfirmType,
                pass: true
              }"
              @updatePass="updateConfirmPass"
              v-model="re_password"
            />
          </div>

          <!--           <div style="overflow: hidden; height: 100px;">
            <vue-recaptcha
              sitekey="6LcG8W4UAAAAAKfUwS1VM07rakvrZT4cgxMGOQXS"
              style="position: absolute;left: 50%; transform: translateX(-50%);"
              @verify="verified = true"
            ></vue-recaptcha>
          </div> -->
          <button type="submit" class="redbtn">
            Зарегистрироваться
          </button>
        </form>
      </ValidationObserver>
    </div>

    <!-- <form @submit.prevent="register()">
      <div class="popup__body">
        <span class="input__title input__requier">
          Логин<span>*</span>:
        </span>
        <input class="input" type="text" autofocus v-model="login" />

        <span class="input__title input__requier">
          Email<span>*</span>:
        </span>
        <input class="input" type="text" v-model="email" />

        <span class="input__title input__requier">
          Пароль<span>*</span>:
        </span>
        <input class="input" type="password" v-model="password" />

        <span class="input__title input__requier">
          Повторить пароль<span>*</span>:
        </span>
        <input class="input" type="password" v-model="re_password" />

        <div style="overflow: hidden; height: 100px;padding: 10px">
          <vue-recaptcha
            sitekey="6LcG8W4UAAAAAKfUwS1VM07rakvrZT4cgxMGOQXS"
            style="position: absolute;left: 13px"
            @verify="verified = true"
          ></vue-recaptcha>
        </div>

        <input
          type="checkbox"
          class="checkbox"
          id="checkbox"
          v-model="privacy"
        />
        <label for="checkbox">С правилами сервиса ознакомлен и согласен</label>

        <button class="btn btn__blue popup__register-btn">
          Зарегистрироваться
        </button>
      </div>
    </form> -->
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
//
//
import { mapState, mapActions } from "vuex";
//
import AppInput from "@/components/ui/AppInput.vue";
export default {
  name: "RegisterModal",

  props: ["modal", "bg"],

  data() {
    return {
      verified: false,
      login: "",
      email: "",
      password: "",
      re_password: "",
      passwordType: "password",
      passwordConfirmType: "password",
      privacy: false
    };
  },

  computed: {
    ...mapState(["referal"]),
    popupClasses() {
      if (window.screen.width < 680) {
        return ["mobpopup"];
      } else {
        return ["popup"];
      }
    }
  },

  methods: {
    ...mapActions("modals", ["closeModal"]),
    ...mapActions("modals", ["openModal"]),
    ...mapActions("auth", ["userLogin", "userRegister"]),
    updatePass(val) {
      if (val) this.passwordType = "text";
      else this.passwordType = "password";
    },
    updateConfirmPass(val) {
      if (val) this.passwordConfirmType = "text";
      else this.passwordConfirmType = "password";
    },
    Login() {
      this.openModal({
        name: "login",
        success: this.userLogin
      });
      this.closeModal(this.modal.name);
    },

    register() {
      /*       if (!this.verified) {
        return alert("Подтвердите что вы не робот!");
      } */
      //
      // if (!this.privacy) {
      //   return alert("Вы не согласились с правилами сервиса!");
      // }
      //
      if (this.password !== this.re_password) {
        return alert("Пароли не совпадают!");
      }
      //
      if (this.password.length < 6) {
        return alert("Пароли пароль должен быть не меньше 6 символов!");
      }
      //
      let data = {
        login: this.login,
        email: this.email,
        password: this.password
      };

      if (this.referal) {
        data.referal = this.referal;
      }
      //
      return this.modal.success(data).then(response => {
        if (response) {
          this.closeModal(this.modal.name);
        }
      });
      //
    }
  },

  components: { VueRecaptcha, AppInput }
};
</script>

<style scoped>
.inputblock-reg {
  padding: 10px 20px 0px 20px;
  border-radius: 20px;
  flex: 1 0 0;
  border: 2px solid var(--main-black);
  border-bottom: 4px solid var(--main-black);
}
@media screen and (max-width: 680px) {
  .inputblock-reg {
    padding: 5px 10px 0px 10px;
    border-radius: 10px;
    flex: 1 0 0;
    border: 2px solid var(--main-black);
    border-bottom: 4px solid var(--main-black);
  }
}
.subtitle {
  color: rgba(26, 24, 20, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Modals/Register.vue